export function rem(pixel: number) {
  return `${pixel / 16}rem`;
}
